import classNames from 'classnames'
import style from './SideForm.module.scss'

const SideForm = ({onSubmit, title, content, toggleEdit, active}) => {

  return (
    <form onSubmit={onSubmit} className={classNames(style.edit, active && style.active)}>
        <span className={style.close} onClick={toggleEdit}>x</span>
        <h1>{title}</h1>
        {content}
    </form>
  )
}

export default SideForm